<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7"  style="margin-top: 38px;">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">欢迎，请先登录</h1>
              <p class="text-lead text-white">您的量化AI智能交易助手，欢迎免费注册</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center" style="margin-top: -158px;">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small></small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="email"
                    prepend-icon="ni ni-email-83"
                    placeholder="请输入您的邮箱"
                    v-model="model.email"
                  >
                  </base-input>


                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="请输入您的密码"
                    v-model="model.password"
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type=""
                      class="my-4"
                      @click.native="registerBtnClicked()"
                      >新用户注册</base-button
                    >
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >登录</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import loginApi from "../../api/login";
import swal from "sweetalert2";

export default {
 
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
     
    };
  },
  methods: {
    async onSubmit() {
      // console.log("-=-=onSubmit", this.model.email);

      const {email,password} = this.model;
      if(email == "" || password == "")
      {
         
        return;
      }

      const data = await loginApi.doLogin({
        email: this.model.email,
        pwd: this.model.password,
      });

      if (data.code == 200) {
        const { user, token } = data.data;

        localStorage.setItem("authorization", token);
        localStorage.setItem("userInfo", JSON.stringify(user));
        this.$router.push("/");
      } else {
        const { err_msg } = data;
        swal
          .fire({
            title: err_msg || `登录失败！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {
            window.location.href = "/#/login";
          });
      }
    },
    registerBtnClicked()
    {
      window.location.href = "/#/register";
      // swal
      //     .fire({
      //       title: `内测期间为邀请注册制，\n欢迎和我们联系！`,
      //       buttonsStyling: false,
      //       customClass: {
      //         confirmButton: "btn btn-success btn-fill",
      //       },
      //       confirmButtonText: "确定",
      //     })
      //     .then(function () {
      //       window.location.href = "/";
      //     });
    }
  },
  mounted()
  {
    const userInfo = localStorage.getItem("userInfo");
    const authorization = localStorage.getItem('authorization')

    let isLogin = false;
    if(authorization != null && userInfo == null || userInfo == "" || userInfo == undefined)
    {
      isLogin = false;
    }else{
      const user = JSON.parse(userInfo);
      if(user && user.username != "" && user.username != null)
      {
        isLogin = true;
      }
    }

    if(isLogin)
    {
      window.location.href = "/#/AI";
    }
  }
};
</script>
